//CSSをバンドル
import 'Src/scss/school-search.scss'
//共通のJavaScriptを読み込み
import 'Src/js/utils/utils'



/* ここには、表示するリストの数を指定します。 */
var moreNum = 10;

/* 表示するリストの数以降のリストを隠しておきます。 */
$('.SchSrchConts__item:nth-child(n + ' + (moreNum + 1) + ')').addClass('is-hidden');


/* 全てのリストを表示したら「もっとみる」ボタンをフェードアウトします。 */
$('.SchSrchConts__more').on('click', function() {
  $('.SchSrchConts__item.is-hidden').slice(0, moreNum).removeClass('is-hidden');
  if ($('.SchSrchConts__item.is-hidden').length == 0) {
    $('.SchSrchConts__more').fadeOut();
  } 
});

/* リストの数が、表示するリストの数以下だった場合、「もっとみる」ボタンを非表示にします。 */
  var list = $(".SchSrchConts__item").length;  
    if (list < moreNum) {
      $('.SchSrchConts__more').addClass('is-btn-hidden');
  }